export default "__VITE_ASSET__C6X2pmws__"